import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { CUSTOM_RELATIONS_QUERY_KEY } from './useFetchAnnotationCustomRelations';

export const useDeleteCustomRelation = () => {
  const intl = useIntl();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (relationId: ID) =>
      api.request(endpoints.relations.delete(relationId)),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CUSTOM_RELATIONS_QUERY_KEY],
      });
    },

    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'features.customRelations.errors.deleteRelation',
        }),
      });
    },
  });
};
